import React from 'react';

interface TypingIndicatorProps {
  agentBubbleColor: string;
}

export const TypingIndicator: React.FC<TypingIndicatorProps> = ({ agentBubbleColor }) => {
  return (
    <div className="flex justify-start px-4 pb-2" role="status" aria-label="Agent is typing">
      <div
        className="rounded-2xl px-4 py-3 flex items-center gap-1.5"
        style={{ backgroundColor: agentBubbleColor }}
      >
        <span className="typing-dot w-2 h-2 rounded-full bg-gray-400 inline-block" aria-hidden="true" />
        <span className="typing-dot w-2 h-2 rounded-full bg-gray-400 inline-block" aria-hidden="true" />
        <span className="typing-dot w-2 h-2 rounded-full bg-gray-400 inline-block" aria-hidden="true" />
      </div>
    </div>
  );
};
